module.exports = __webpack_public_path__ + "img/icon_tips_success.5550cb3c.png";